import { css } from '@emotion/react';
import {
  type FC, type ReactNode,
} from 'react';
import { useTheme } from '~/_shared/themes/theme.hooks';
import { type ThemeProps } from '~/_shared/types/themeProps';
import { useTranslation } from '~/_shared/utils/hooks';

type BoundarySettingsTableProps = Readonly<{
  dataHeadingLabel: string;
  dataRows: ReactNode;
  className?: string;
}>;

const tableStyle = css({
  width: '100%',
  borderSpacing: 0,
  borderCollapse: 'collapse',
});

const tableHeadingStyle = ({ theme }: ThemeProps) => css({
  color: theme.textColors.secondary,
  textTransform: 'uppercase',
  fontSize: '14px',
  padding: '16px 8px 16px 0',
  textAlign: 'left',
  '&:first-of-type': {
    paddingLeft: 16,
    paddingRight: 8,
  },
});

const tablePrimaryColumnStyle = css({
  width: '50%',
});

export const BoundarySettingsTableComponent: FC<BoundarySettingsTableProps> = (props) => {
  const [t] = useTranslation();
  const theme = useTheme();

  return (
    <table css={tableStyle} className={props.className}>
      <thead>
        <tr>
          <th css={tableHeadingStyle({ theme })}>{t('Fill Color')}</th>
          <th css={tableHeadingStyle({ theme })}>{t('Fill Opacity')}</th>
          <th css={[tableHeadingStyle({ theme }), tablePrimaryColumnStyle]}>{props.dataHeadingLabel}</th>
        </tr>
      </thead>
      <tbody>
        {props.dataRows}
      </tbody>
    </table>
  );
};
